import React from "react"
import { Link } from "gatsby"

import "normalize.css"
import "./css/style.css"

import Menu from "./menu"

class Layout extends React.Component {
  render() {
    const { location, title, children } = this.props
    const rootPath = `${__PATH_PREFIX__}/`
    let header

    if (location.pathname === rootPath) {
      header = (
        <h3>
          <Link to={`/`}>{title}</Link>
        </h3>
      )
    } else {
      header = (
        <h3>
          <Link to={`/`}>{title}</Link>
        </h3>
      )
    }
    return (
      <div className="wrapper">
        <div className="header"><header>{header}</header></div>
        <div className="navigation"><Menu/></div>
        <div className="content">
          <main>{children}</main>
        </div>
        <div className="footer"><p className="copyRight">© 2008-{new Date().getFullYear()}, xkln.net</p></div>
      </div>
    )
  }
}

export default Layout
